export const getDisplayName = o => {
  if (o.name) {
    return o.name;
  }

  if (o.fullName) {
    return o.fullName;
  }

  const { firstName, lastName, emailAddress } = o;

  if (lastName && firstName) {
    return `${lastName} ${firstName}`;
  }

  if (lastName) {
    return lastName;
  }

  if (firstName) {
    return firstName;
  }

  if (emailAddress) {
    return `Unnamed (${emailAddress})`;
  }

  return 'Unknown';
};
